// AUTO-GENERATED by scripts/genVersion.js at build time — do not edit.
export const BUILD_VERSION = "0.1.0+20260924T151700Z";
